module.exports = __webpack_public_path__ + "static/media/uy.48a1aea3.webp";